import { Component } from '@angular/core';

@Component({
  selector: 'ui-card-title',
  templateUrl: './card-title.component.html',
  styleUrls: ['./card-title.component.scss'],
})
export class CardTitleComponent {}
